'use client';

import {Chip} from './Chip';

export interface SoldOutLabelProps {
  label: string;
}

export function SoldOutLabel({label}: SoldOutLabelProps) {
  return (
    <Chip
      color="light"
      size="medium"
      sx={theme => ({
        backgroundColor: theme.palette.colors.surface.soldoutLabel,
        color: theme.palette.colors.text.soldoutLabelText,
      })}
    >
      {label}
    </Chip>
  );
}

SoldOutLabel.displayName = 'SoldOutLabel';
